import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import clsx from "clsx";
import { forwardRef } from "react";
import classes from "./radio-group.module.css";

export const Root = forwardRef<
  React.ElementRef<typeof RadixRadioGroup.Root>,
  React.ComponentPropsWithoutRef<typeof RadixRadioGroup.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadixRadioGroup.Root
      ref={ref}
      className={clsx(classes.root, className)}
      {...props}
    />
  );
});

Root.displayName = "Root";

type ItemProps = React.ComponentPropsWithoutRef<typeof RadixRadioGroup.Item> & {
  id: string;
};

export const Item = forwardRef<
  React.ElementRef<typeof RadixRadioGroup.Item>,
  ItemProps
>(({ id, className, ...props }, ref) => {
  return (
    <RadixRadioGroup.Item
      ref={ref}
      className={clsx(classes.icon, className)}
      id={id}
      {...props}
    >
      <RadixRadioGroup.Indicator />
    </RadixRadioGroup.Item>
  );
});
Item.displayName = "Item";
